<div class="response-container">
  <div class="response-container__header">
    <div class="response-container__header-title">
      <div class="error-icon">
        <img src="assets/icons/error-icon.svg" alt="" />
      </div>

      {{ title }}
    </div>
    <div class="close-icon">
      <img alt="" (click)="onClose()" src="../.././../../../assets/icons/x-delivery-services.svg" />
    </div>
  </div>
  <div class="text">
    <div class="response-container__text">{{ message }}</div>
    <div class="response-container__text margin-top">
      If you're still having trouble, please reach out to
      <a href="mailto:support@prettydamnquick.com">support&#64;prettydamnquick.com</a>
    </div>
  </div>

  <div class="response-container__actions">
    <span class="margin-auto">
      <pdq-button (onClick)="onClose()" label="OK got it"></pdq-button>
    </span>
  </div>
</div>
